import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { EncryptionService } from './encryption.service';
interface User {
    username: string;
    position: string;
    token?: string;
    email: string;
}
interface MenuDigi {
  formUrl: string;
  formName: string;
  unreadCount: string;
}
export enum Roles {
  SuperAdmin = 'Super Admin',
  Admin = 'Admin',
  Employee = 'Employee',
  Developer = 'Developer',
  Guest = 'Guest'
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  private currentMenuSubject: BehaviorSubject<MenuDigi>;
  public currentUser: Observable<User>;
  public currentMenu: Observable<MenuDigi>;
  // apiUrlw = 'http://localhost:3003';
  // apiUrl = 'http://localhost:3003/api';
  apiUrlw = 'https://demo.compubrain.com:3003';
  apiUrl = 'https://demo.compubrain.com:3003/api';
  constructor(private http: HttpClient, private router: Router, private encryptSer: EncryptionService) {
    if(typeof(localStorage.getItem('currentUser')) == 'string')
    {
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(this.encryptSer.decryptData(localStorage.getItem('currentUser'))));
      this.currentUser = this.currentUserSubject.asObservable();
    }
    else{
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
      this.currentUser = this.currentUserSubject.asObservable();
    }
    this.currentMenuSubject = new BehaviorSubject<MenuDigi>(JSON.parse(localStorage.getItem('currentMenu')));
    this.currentMenu= this.currentMenuSubject.asObservable();
  }

  isUSerLogin(userId:any){
    if (sessionStorage.getItem('token')) {
      let token:any = sessionStorage.getItem('token').slice(0, -4);
      let decode:any = jwtDecode(token)
      var dateNow = Date.now()/1000;
      console.log(decode.exp < dateNow)
      if(decode.exp < dateNow)
      {
        return false;
      }
      else
       return true
    } else {
      return false;
    }
  }
  getUserData(){
    if (sessionStorage.getItem('token')) {
      let token:any = sessionStorage.getItem('token').slice(0, -4);
      let decode:any = jwtDecode(token);
       return decode
    } else {
      return {};
    }
  }
  getUserRole(){
    if (sessionStorage.getItem('token')) {
      let token:any = sessionStorage.getItem('token').slice(0, -4);
      let decode:any = jwtDecode(token);
       return decode.position
    } else {
      return '';
    }
  }
  getClientName(){
    if (sessionStorage.getItem('token')) {
      let token:any = sessionStorage.getItem('token').slice(0, -4);
      let decode:any = jwtDecode(token);
       return decode.clientDatabase
    } else {
      return '';
    }
  }
  getClient(){
    if (sessionStorage.getItem('token')) {
      let token:any = sessionStorage.getItem('token').slice(0, -4);
      let decode:any = jwtDecode(token);
      console.log(decode)
       return decode.clientName
    } else {
      return '';
    }
  }
  geturl(){
    return this.apiUrlw;
  }
  getTableName(){
    if (sessionStorage.getItem('token')) {
      let token:any = sessionStorage.getItem('token').slice(0, -4);
      let decode:any = jwtDecode(this.removeInsertedString(token,'cb0212',3));
       return decode.assignedTable
    } else {
      return [];
    }
  }
  removeInsertedString(original: string, toRemove: string, position: number): string {
    if (original.slice(position, position + toRemove.length) === toRemove) {
      return original.slice(0, position) + original.slice(position + toRemove.length);
    } else {
      return original;
    }
  }
  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  public get currentMenuValue(): MenuDigi {
    return this.currentMenuSubject.value;
  }
  setUserData(user:User){
    localStorage.setItem('currentUser', this.encryptSer.encryptData(JSON.stringify(user)));
    this.currentUserSubject.next(user);
  }
  setMenuData(menu:any){
    localStorage.setItem('currentMenu', JSON.stringify(menu));
    this.currentMenuSubject.next(menu);
  }
  loginUser(payload:any) {
    console.log(this.apiUrl);
    return this.http.post(environment.apiUrl+'/auth/login',payload);
  }
  forgotUser(payload:any) {
    return this.http.post(environment.apiUrl+'/auth/forgotPassword',payload);
  }
  updateUser(payload:any) {
    return this.http.post(environment.apiUrl+'/auth/setPassword',payload);
  }
  addUser(payload:any) {
    return this.http.post(environment.apiUrl+'/addUser',payload);
  }
  changePassword(id:any) {
    return this.http.put(environment.apiUrl+'/changePassword/'+id,{});
  }
  updateProject(payload:any) {
    return this.http.post(environment.apiUrl+'/admin/updateProject',payload);
  }
  addProject(payload:any) {
    return this.http.post(environment.apiUrl+'/admin/addProject',payload);
  }
  getAllProject() {
    return this.http.get(environment.apiUrl+'/admin/allProjects');
  }
  editProject(data:any, id:any) {
    return this.http.put(environment.apiUrl+'/admin/editProject/'+id,data);
  }
  deleteProject(id:any) {
    return this.http.delete(environment.apiUrl+'/admin/deleteProject/'+id);
  }
  getProjectById(id:any) {
    return this.http.get(environment.apiUrl+'/admin/getProjectById/'+id);
  }
  getUsers() {
    return this.http.get(environment.apiUrl+'/getUserList');
  }
  updateUserData(payload:any) {
    return this.http.post(environment.apiUrl+'/updateUser',payload);
  }
  deleteUser(id:any) {
    return this.http.delete(environment.apiUrl+'/deleteUser/'+id);
  }
  getMenuData(){
    return this.http.get(environment.apiUrl+'/admin/getAllCollection')
  }
  getTableData(name:any,page:any, fromdate:any, todate:any){
    return this.http.get(environment.apiUrl+'/admin/getInquiry/'+name+'?page='+page.pageNumber+'&fromDate='+fromdate+'&toDate='+todate+'&limit='+page.size)
  }
  updateTableStatus(name:any, data:any){
    return this.http.put(environment.apiUrl+'/admin/updateStatus/'+name,data)
  }
  updateTableNote(name:any, data:any){
    return this.http.put(environment.apiUrl+'/admin/addNote/'+name,data)
  }
  getChartsDetails(){
    return this.http.get(environment.apiUrl+'/admin/getChartsDetails/')
  }
  assignedUser(data:any){
    return this.http.post(environment.apiUrl+'/admin/assignedUser/',data)
  }
  planExpiredOrNot(){
    return this.http.get(environment.apiUrl+'/admin/planIsExpired/')
  }
  allNotification(){
    return this.http.get(environment.apiUrl+'/admin/allNotification/')
  }
  updateNotification(id:any){
    return this.http.put(environment.apiUrl+'/admin/updateNotification/'+id,{})
  }
  markAllRead(clientName:any){
    return this.http.put(environment.apiUrl+'/admin/markAllRead/'+clientName,{})
  }
  getallClientList() {
    return this.http.get(environment.apiUrl+'/admin/allClientList');
  }
  editClient(data:any, id:any) {
    return this.http.put(environment.apiUrl+'/admin/editClient/'+id,data);
  }
  importData(data:any){
    return this.http.post(environment.apiUrl+'/admin/importData/',data)
  }
  logoutUserData(){
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('token');
    if(this.currentUserValue)
      this.currentUserSubject.next(null);
    
    this.router.navigateByUrl('/login');
  }
  sendOtp(mobileNo:any, mobNo:any){
    return this.http.post(environment.apiUrl+'/auth/sendOtp/'+mobNo,mobileNo)
  }
  otplogin(body:any){
    return this.http.post(environment.apiUrl+'/auth/otplogin',body)
  }
  exportdata(pageName:any){
    return this.http.get(environment.apiUrl+'/admin/exportData/'+pageName);
  }
}
